module.exports = __webpack_public_path__ + "img/audio_open.7938dc9f.png";